import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { LoginPage } from './pages/LoginPage';
import { TwoFactorPage } from './pages/TwoFactorPage';
import { TwoFactorSetupPage } from './pages/TwoFactorSetupPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { AccountsPage } from './pages/AccountsPage';
import { InboxPage } from './pages/InboxPage';
import { MessageDetailPage } from './pages/MessageDetailPage';
import { ComposePage } from './pages/ComposePage';
import { Layout } from './components/Layout';

function Loading() {
  return <div className="min-h-screen flex items-center justify-center text-slate-500">Laden …</div>;
}

function Protected({ children }: { children: JSX.Element }) {
  const { me, loading, mfaVerified } = useAuth();
  if (loading) return <Loading />;
  if (!me) return <Navigate to="/login" replace />;
  if (me.totpEnabled && !mfaVerified) return <Navigate to="/2fa" replace />;
  if (!me.totpEnabled) return <Navigate to="/2fa-setup" replace />;
  if (me.mustChangePassword) return <Navigate to="/passwort-aendern" replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/2fa" element={<TwoFactorPage />} />
      <Route path="/2fa-setup" element={<TwoFactorSetupPage />} />
      <Route path="/passwort-aendern" element={<ChangePasswordPage />} />
      <Route path="/" element={<Protected><AccountsPage /></Protected>} />
      <Route path="/account/:accountId/inbox" element={<Protected><InboxPage /></Protected>} />
      <Route path="/account/:accountId/inbox/:mailbox" element={<Protected><InboxPage /></Protected>} />
      <Route path="/account/:accountId/message/:mailbox/:uid" element={<Protected><MessageDetailPage /></Protected>} />
      <Route path="/account/:accountId/compose" element={<Protected><ComposePage /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
